import { Container, Graphics } from 'pixi.js';
import { COLORS, DESIGN_W, SCRIM } from '../app/theme';
import { viewport } from '../app/viewport';
import { Button, Panel, makeText } from './widgets';

export interface DialogOpts {
  title?: string;
  message: string;
  okText?: string;
  onClose?: () => void;
}

/**
 * A modal dialog covering the design space. Used for SendMessage(0) toasts, admin messages, version
 * prompts and confirmations. Add it to the uiLayer (above scenes); it removes itself on OK.
 */
export class Dialog extends Container {
  constructor(opts: DialogOpts) {
    super();
    const overlay = new Graphics().rect(0, 0, DESIGN_W, viewport.h).fill({ color: COLORS.scrim, alpha: SCRIM.dialog });
    overlay.eventMode = 'static'; // swallow taps behind the dialog
    this.addChild(overlay);

    const boxW = 580;
    const boxH = 360;
    const panel = new Panel(boxW, boxH);
    panel.position.set((DESIGN_W - boxW) / 2, (viewport.h - boxH) / 2);
    this.addChild(panel);

    let y = 36;
    if (opts.title) {
      const title = makeText(opts.title, { size: 30, weight: '700', align: 'center', fill: COLORS.gold });
      title.anchor.set(0.5, 0);
      title.position.set(boxW / 2, y);
      panel.addChild(title);
      y += 60;
    }

    const message = makeText(opts.message, { size: 24, align: 'center' });
    message.style.wordWrap = true;
    message.style.wordWrapWidth = boxW - 64;
    message.anchor.set(0.5, 0);
    message.position.set(boxW / 2, y);
    panel.addChild(message);

    const ok = new Button(opts.okText ?? 'باشه', () => this.close(opts.onClose), {
      width: boxW - 96,
      height: 60,
    });
    ok.position.set(48, boxH - 84);
    panel.addChild(ok);
  }

  private close(onClose?: () => void): void {
    this.parent?.removeChild(this);
    this.destroy({ children: true });
    onClose?.();
  }
}
